import { element } from 'protractor';
import { Component, OnInit , ViewChild , ElementRef } from '@angular/core';
import { UrlHandlingStrategy } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { StatistiquesService } from 'src/app/Service/statistiques.service';
import * as _ from 'lodash';
import { SharedService } from 'src/app/Service/shared.service';


@Component({
  selector: 'app-statistiques',
  templateUrl: './statistiques.component.html',
  styleUrls: ['./statistiques.component.scss']
})

export class StatistiquesComponent implements OnInit {
  @ViewChild('iframe1') iframe: ElementRef;

  ngAfterViewInit() {
    this.iframe.nativeElement.src = "/PubReporting/index.html";
    console.log(" element : " + this.iframe.nativeElement.src);
  }

  constructor(private service:StatistiquesService, public global:Global, private shared: SharedService) {}
  bloc = {
    Titre: "",
    Contenu: ""
  }
  RapportsDeSynthese = [];
  StatistiquesMensuelle = [];
  StatistiquesAnnuel = [];
  SelectedRapportsDeSynthese = null;
  SelectedStatistiquesMensuelle = null;
  SelectedStatistiquesAnnuel = null;
  UrlRapportSynthese;
  UrlStatistiqueAnnuel;
  UrlStatistiqueMensuelle;
  DistinctYear = [];
  SelectedMonth = null;
  currentMonths = []
  SelectedYear;
  CurrentLink ='';
  ngOnInit() { 

    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {

      this.RapportsDeSynthese = [];
      this.StatistiquesMensuelle = [];
      this.StatistiquesAnnuel = [];
       
      this.shared.getBlocDescriptionByCode(lg.url, "Statistiques").subscribe(data => {        
        this.bloc.Titre = data["value"][0] ? data["value"][0].Title : "";
        this.bloc.Contenu = data["value"][0] ? data["value"][0].Contenu : "";
      })

      this.service.getRapportDeSynthese(this.global._basedUrl+ this.global._FrUrl).subscribe(datas=> {
          /* const obj = {
            Annee : 'Merci de saisir une année'
          }
          this.RapportsDeSynthese.push(obj); */
          datas["value"] = datas["value"].filter(item => typeof item['Annee'] === 'number').sort((a, b) => b['Annee'] - a['Annee'] );
          datas["value"].forEach(element => {            
            this.RapportsDeSynthese.push(element);
          });          
          this.SelectedRapportsDeSynthese = datas !== null  ? datas["value"][0].File.ServerRelativeUrl : null;
       }); 
       this.service.getStatistiqueMensuelle(this.global._basedUrl+ this.global._FrUrl).subscribe(datas=> {
          //datas["value"] = datas["value"].filter(item => typeof item['Annee'] === 'number').sort((a, b) => b['Annee'] - a['Annee'] );
          this.StatistiquesMensuelle = datas["value"];
          this.DistinctYear =  _.uniq(_.map(datas["value"], 'Annee'));
          this.currentMonths = this.DistinctYear.length > 0 ? this.changeYear(this.DistinctYear[0]): [];
          this.currentMonths = this.currentMonths .sort((a, b) => +b - +a );
          this.SelectedMonth =  this.currentMonths.length > 0 ? this.currentMonths[0] : null;
          this.CurrentLink = this.currentMonths.length > 0 ? this.currentMonths[0].File.ServerRelativeUrl : null;
          this.changeMonth(this.CurrentLink) 
       });

       this.service.getStatistiqueAnnuel(this.global._basedUrl+ this.global._FrUrl).subscribe(datas=> {
        datas["value"] = datas["value"].filter(item => typeof item['Annee'] === 'number').sort((a, b) => b['Annee'] - a['Annee'] );
        datas["value"].forEach(element => {
          this.StatistiquesAnnuel.push(element);
        });        
        this.SelectedStatistiquesAnnuel = datas !== null  ? datas["value"][0].File.ServerRelativeUrl  : null;
      }); 
    });
  }
  DownloadTarget(target) {
    if(target)
    {
      target = this.global._baseUrlStatique + target;
      var redirect = window.open(target,'_blank');
      redirect.location;
    }
  }
  StatistiqueMonths(SelectedYear){
    return this.StatistiquesMensuelle.filter(element => element.Annee == SelectedYear.value);
  }
  changeMonth(event) {
    // const link = document.getElementById('downloadReportM');
    // event !== null  ?link.setAttribute('href',this.global._baseUrlRacine + event ) : null;
    this.UrlStatistiqueMensuelle =  event !== null  ? event  : null;
  }
  changeYear(year) {
    
    this.currentMonths = this.StatistiquesMensuelle.filter(element => element.Annee == year);
    this.currentMonths = this.currentMonths .sort((a, b) => a['Mois'] - b['Mois']  );
    this.SelectedMonth =  this.currentMonths.length > 0 ? this.currentMonths[0] : null;
    this.CurrentLink = this.currentMonths.length > 0 ? this.currentMonths[0].File.ServerRelativeUrl : null;
    this.changeMonth(this.CurrentLink) 
    const result =this.StatistiquesMensuelle.filter(element => element.Annee == year);
    result.sort((a, b) => +b['Mois'] - +a['Mois'] );
      return  result
  }
  ChangeRapportDeSynthese(event){
    this.UrlRapportSynthese =  event !== null  ? this.global._baseUrlRacine + event  : null;
  }
  ChangeStatistiqueAnnuel(event){
    this.UrlStatistiqueAnnuel =  event !== null  ? this.global._baseUrlRacine + event  : null;
  }    
}
